import { render, staticRenderFns } from "./totalServiceTime.vue?vue&type=template&id=3c4687b4&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./totalServiceTime.vue?vue&type=style&index=0&id=3c4687b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4687b4",
  null
  
)

export default component.exports